<template>
    <b-modal
            class="modal"
            id="refChangeLogs"
            ref="refChangeLogs"
            hide-footer
            size="xl"
            title="Change Logs"
            @hidden="hidden"
    >

                <div class="card" style="margin-bottom: 10px" v-for="change in vChanges">
                    <div class="card-body">
                        <div class="form-group">
                            Updated at : <span class="badge badge-primary">{{change.created_at | moment}}</span> <br>
                            Changes : <br><span class="badge  wordWrap" style="margin-left: 50px">{{change.change_log}}</span>
                        </div>
                    </div>
                </div>

    </b-modal>


</template>

<script>
    import * as changeLogs from "../../services/changeLogs.js";
    import moment from 'moment';

    export default {
        name: "showChangeLogs",
        props: {
            id: '',
            latest_id: '',
        },
        data() {
            return {
                vChanges: [],
            }
        },
        filters: {
            moment: function (date) {
                return moment(date).format('MMMM D, YYYY, h:mm:ss a');
            }
        },
        methods: {
            hidden(){
                localStorage.setItem("change_log", this.latest_id);
            },
            async getChanges() {
                const response = await changeLogs.getChanges( this.id);
                this.vChanges = response.data;

            },
        },
        mounted(){
            this.getChanges();
            this.$refs.refChangeLogs.show();
        }
    }
</script>

<style scoped>
    .wordWrap {
        word-wrap: break-word; /* IE 5.5-7 */
        white-space: -moz-pre-wrap; /* Firefox 1.0-2.0 */
        white-space: pre-wrap; /* current browsers */
        text-align: left;
        font-size: 30px;
    }
</style>